<template>
  <v-row class="text-center">
    <v-col cols="12">
      <v-progress-linear :indeterminate="true" v-if="isLoading" color="primary"></v-progress-linear>
      <GChart
        v-else
        type="ColumnChart"
        :data="chartData"
        :options="chartOptions"
        width="100%"
      />
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { GChart } from 'vue-google-charts/legacy';
import dayjs from 'dayjs';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'GraphRecurringProfit',
  mixins: [loading],
  module: 'Reports',
  components: {
    GChart,
  },
  props: {
    lineType: {
      type: String,
      default: 'Monthly Recurring Cost',
    },
    target: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapState('currencies', ['selectedCurrency']),
    ...mapGetters('currencies', ['currencySymbol']),
    chartData() {
      const { target, items } = this;
      const data = [['Status', 'Total Profit', 'Target']];
      for (let index = -2; index < 10; index += 1) {
        const month = new Date();
        month.setMonth(month.getMonth() + index);
        const total = items
          .filter((item) => dayjs(item.agreement.deliveredDate).isSame(month, 'month'))
          .reduce((sum, item) => sum + item.profit, 0);
        const twelveMonthsFromTodayLabel = dayjs(month).format('MMM YYYY');
        data.push([twelveMonthsFromTodayLabel, total, target]);
      }
      return data;
    },
    maxValue() {
      const { chartData } = this;
      const profits = chartData
        .slice(1)
        .map((row) => row.slice(1).reduce((sum, value) => sum + value, 0));
      return Math.max(...profits) * 1.1;
    },
    chartOptions() {
      const { maxValue } = this;
      return {
        animation: {
          duration: 1000,
          easing: 'out',
        },
        chart: {
          title: 'Overview',
        },
        vAxis: {
          format: `${this.currencySymbol} #,###`, title: '', minValue: 0, maxValue,
        },
        hAxis: {
          minorGridlines:
        { minSpacing: 100 },
          title: '',
        },
        height: 280,
        colors: ['#1C1C65', '#951daa'],
        legend: { position: 'top' },
        // isStacked: true,
        annotations: {
          alwaysOutside: true,
          stem: {
            length: 5,
          },
          textStyle: {
            // The color of the text.
            color: '#000000',
          },
        },
      };
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    /**
     * Executes refresh
     */
    async refresh() {
      this.isLoading = true;
      this.items = [];
      let url = 'odata/incomeLines?';
      url += '$filter=agreement/Status eq \'Delivered\' AND isDeleted eq false AND isActive eq true';
      url += ` AND lineType eq '${this.lineType}'`;
      url += '&$expand=agreement($select=deliveredDate)';
      const { data } = await this.$http.get(url);
      this.items = data.value;
      this.isLoading = false;
    },
  },
};
</script>
